import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import apolloLogger from 'apollo-link-logger';
import logError from '../lib/log-error';
import { BatchHttpLink } from '@apollo/client/link/batch-http';

const getClientInstance = ({
  uri = `${window.SCREENFLOW_HOST}/v5/graphql`,
  credentials = 'same-origin',
  envelop = window.TELADOC_ENVELOP,
  logger = logError,
  cacheOptions = {},
  defaultOptions = {},
} = {}) => {
  const headers = { ...envelop, 'X-Requested-With': 'XMLHttpRequest' };

  if (process.env.NODE_ENV === 'test') return () => {};

  return new ApolloClient({
    link: ApolloLink.from([
      apolloLogger,
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          graphQLErrors.map(({ message, locations, path }) => logger({ message, locations, path }));
        }
        if (networkError) logger({ message: 'Network error', networkError });
      }),
      require('graphql-ruby-operation-store').apolloLink,
      new BatchHttpLink({
        uri,
        credentials,
        headers,
        batchInterval: 100
      })
    ]),
    cache: new InMemoryCache(cacheOptions),
    defaultOptions,
  });
};

export default getClientInstance;
